module.exports = __webpack_public_path__ + "static/media/transferStudent.bd6a873d.JPG";